<template>
    <div class="task-group mb-3">
        <b class="task-group-name">{{ agentName }}</b>

        <div class="inner inner-bottom">

            <task v-for="task in tasks"
            :task="task"
             :key="`task-${task.id}`"></task>

        </div>
    </div>
</template>

<script>
import Task from './Task.vue';

export default {
    name: "TaskGroup",
    components: {Task},
    props: ['tasks', 'agentName'],
    mixins: [],

    data() {
        return {}
    },

    methods: {},

    computed: {}
}
</script>

<style scoped lang="scss">
.task-group {
    background: #fff;
    border-radius: 5px;

    .task-group-name {
        display: block;
        padding-top: 15px;
        padding-bottom: 8px;
        font-weight: 600;
        color: #2c5cc5;
        padding-left: 15px;
        padding-right: 15px;
    }

    .inner {
        padding-left: 15px;
        padding-right: 15px;
    }

    .inner-bottom {
        padding-top: 0;
        // padding-bottom: 12px !important;
        font-size: 12px;
    }
}
</style>
